import React, { useEffect, useState } from 'react';
import {
  ModalActionContainer,
  ModalActionContent,
  ModalActionHead,
  ModalActionBody,
  ModalActionBodyIcon,
  ModalActionBodyLabel,
  ModalActionBodyDescription,
  ModalActionFooterButton,
} from './styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';
import InputDefault from '../../components/InputDefault';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { Form, FormFooter, FormRow } from '../../components/FormTemplate/styles';

const ModalActionSendSimulation = ({ title, description, open, bodyIcon, rotateIcon, setShowModal, actionFunctionDownButton, backgroundIcon, onSubmit, defaultMail }) => {
  const { control, errors, handleSubmit, register, setValue } = useForm();
  const [correo, setCorreo] = useState('');
  const emailValue = useWatch({ control, name: 'email' })

  useEffect(() => {
    if (defaultMail){
      setCorreo(defaultMail);
      setValue("correo", defaultMail);
    }
  }, [defaultMail]);

  const onChangeEmail = (e) => {
    const lowercaseEmail = e.target.value.toLowerCase();
    setValue('email', lowercaseEmail);
      }

    useEffect(() => {
      const lowercaseEmail = emailValue.toLowerCase();
      setValue('email', lowercaseEmail);
    }, [emailValue, setValue]);

  return (
    <ModalActionContainer open={open} id="modal-action">
      <ModalActionContent>
        <ModalActionHead setShowModal={setShowModal}>
          {setShowModal && <IoClose size={26} color={colors.textSecondary} onClick={() => setShowModal(false)} id="close-icon" />}
        </ModalActionHead>
        <ModalActionBody>
          <ModalActionBodyIcon backgroundIcon={backgroundIcon} rotateIcon={rotateIcon}>
            {bodyIcon}
          </ModalActionBodyIcon>
          <ModalActionBodyLabel>
            {title}
          </ModalActionBodyLabel>
          {description && (
            <ModalActionBodyDescription>
              {description}
            </ModalActionBodyDescription>
          )}
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormRow col="1">
              <Controller
                as={InputDefault}
                control={control}
                error={errors.correo}
                label="Correo electrónico"
                name="correo"
                onChange={onChangeEmail}
                id="correo"
                value={correo}
                register={register({
                  required: "Este dato es obligatorio",
                  pattern: {
                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                    message: "El correo electrónico tiene un formato inválido",
                  },
                })} />
            </FormRow>
            <FormFooter justify="flex-end" style={{ "margin-top": "10px" }}>
              <ModalActionFooterButton onClick={() => actionFunctionDownButton()} id="bottom-action-button">Cancelar</ModalActionFooterButton>
              <ModalActionFooterButton type="submit" id="top-action-button">Enviar</ModalActionFooterButton>
            </FormFooter>
          </Form>
        </ModalActionBody>
      </ModalActionContent>
    </ModalActionContainer>
  )
}

export default ModalActionSendSimulation
